<template>
  <div class="relative">
    <div v-if="!prefilledEducationComplete || !prefilledCareerPassportComplete"
         class="mx-auto grid max-w-3xl grid-cols-1 gap-4"
         :class="!prefilledEducationComplete && !prefilledCareerPassportComplete && 'md:grid-cols-2'">
      <div v-if="!prefilledCareerPassportComplete" class="col-span-1 max-w-3xl">
        <FormLabel label="Add Your Work History" label-hint="(1 Entry Required)"/>
        <AnswerItemList :question="candidateCareerPassport.passport"
                        :use-store="useStore"/>
      </div>
      <div v-if="!prefilledEducationComplete" class="col-span-1 max-w-3xl">
        <FormLabel label="Add Your Education" label-hint="(1 Entry Required)"/>
        <AnswerItemList :question="candidateEducationBadges.education"
                        :use-store="useStore"/>
      </div>
    </div>
    <div v-if="!prefilledExceptionalAbilityComplete" class="mx-auto mt-8 mb-12 max-w-3xl">
      <FormLabel label="Your 3 Exceptional Abilities" label-hint="(Required)"/>
      <div class="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <FormInput v-for="(num) in 3"
                   :key="num"
                   :label="`Ability #${num}`"
                   :placeholder="`Ability #${num}`"
                   v-model="store.state.exceptionalAbility[num - 1]"
                   class="col-span-1"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {candidateCareerPassport, candidateEducationBadges} from "../helpers/ProfileQuestions.js";
import FormLabel from "./FormLabel.vue";
import FormInput from "./FormInput.vue";
import AnswerItemList from "./AnswerItemList.vue";

const props = defineProps({
  prefilledEducationComplete: Boolean,
  prefilledCareerPassportComplete: Boolean,
  prefilledExceptionalAbilityComplete: Boolean,
  useStore: Function,
  useTwoColumns: Boolean,
});

const store = props.useStore();
</script>
